import { Button, Modal } from 'react-bootstrap';

import { defaultTheme } from '../../assets/css/defaultTheme';
//show={showAssociateModal} setShow={setShowAssociateModal} data={infos} setData={setInfos}

const ModalCancelOrder = (props: any) => {
  const handleClose = () => {
    props.setShow(false);
  };

  const validate = () => {
    //Prepare data
    handleClose();
  };

  return (
    <Modal show={props.show} onHide={handleClose}>
      <div className="d-flex flex-column justify-content-center m-4">
        <p
          className="mb-2 pb-0 fw-bolder text-center"
          style={{ color: defaultTheme.palette.primary.dark, fontFamily: defaultTheme.typography.fontFamily }}
        >
          Annuler une commande
        </p>
        <div className="mt-3 d-flex flex-column justify-content-center text-center w-100">
          <p>L'annulation de cette commande entraînera le remboursement suivant : </p>
          <p className="text-danger">Remboursement à hauteur de 50% de la prestation</p>
        </div>
        <div className="mt-3 d-flex flex-row justify-content-center w-100">
          <Button variant="primary" onClick={() => validate()}>
            Confirmer l'annulation de la commande #{props.orderId}
          </Button>
        </div>
        <div className="mt-2 d-flex flex-row justify-content-center w-100">
          <Button variant="outline-primary" onClick={() => handleClose()}>
            Conserver la commande #{props.orderId}
          </Button>
        </div>
        <div className="register-info2 mt-3 text-muted d-flex flex-column justify-content-center text-center">
          <strong className="mt-0 mb-0">Modalités d'une annulation de commande :</strong>
          <p className="mt-0 mb-0">plus de 72h avant la commande : 25% de retenu sur la prestation</p>
          <p className="mt-0 mb-0">72h avant la commande : 50% de retenu sur la prestation</p>
          <p className="mt-0 mb-0">48h avant la commande : 75% de retenu sur la prestation</p>
          <p className="mt-0 mb-0">24h avant la commande : annulation impossible sauf cas exeptionnel</p>
        </div>
      </div>
    </Modal>
  );
};

export default ModalCancelOrder;
